<template>
  <TransitionRoot as="template" :show="isOpen">
    <Dialog as="div" class="relative z-50" @close="close">
      <div class="fixed inset-0 overflow-hidden" @click="close(true)">
        <div
          class="pointer-events-none fixed inset-y-0 right-0 flex w-full"
          :class="isExpanded ? 'max-w-full pl-14' : 'max-w-md'"
        >
          <TransitionChild as="template" enter="transform transition ease-in-out duration-300" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-300" leave-from="translate-x-0" leave-to="translate-x-full">
            <DialogPanel class="pointer-events-auto w-full mt-16">
              <div class="flex h-full flex-col overflow-y-scroll bg-white pb-6 shadow-xl border-l border-primary-300 ">
                <div class="sticky top-0 z-10 px-4 sm:px-6 py-4 bg-primary-200">
                  <div class="flex items-start">
                    <div class="mr-4 flex h-7 items-center shrink-0">
                      <button
                        type="button"
                        class="relative text-gray-600 hover:text-gray-800 focus:outline-none"
                        @click="expand"
                      >
                        <ArrowCollapseAll v-if="isExpanded" class="h-6 w-6" aria-hidden="true" />
                        <ArrowExpandAll v-else class="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                    <DialogTitle class="grow text-base font-semibold leading-6 mt-1 text-primary-900 whitespace-nowrap truncate">{{ title }}</DialogTitle>
                    <div class="ml-4 flex h-7 items-center shrink-0">
                      <button
                        type="button"
                        class="relative text-gray-600 hover:text-gray-800 focus:outline-none"
                        @click="close(true)"
                      >
                        <span class="sr-only">Close panel</span>
                        <Close class="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
                <div class="relative mt-6 flex-1 px-4 sm:px-6">
                  <slot v-if="isExpanded" name="expanded" />
                  <slot v-else />
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>

      <modal-dialog is-overlay-modal />
    </Dialog>
  </TransitionRoot>
</template>

<script setup>
import { ref } from 'vue';
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import Close from 'vue-material-design-icons/Close.vue';
import ArrowExpandAll from 'vue-material-design-icons/ArrowExpandAll.vue';
import ArrowCollapseAll from 'vue-material-design-icons/ArrowCollapseAll.vue';
import ModalDialog from './ModalDialog.vue';

defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: null
  }
});

const emit = defineEmits([ 'close', 'expand' ]);

const isExpanded = ref(false);

function close(realClose = false) {
  // fix for modal over this panel
  if (!realClose) {
    return;
  }

  emit('close');
  isExpanded.value = false;
}

function expand() {
  isExpanded.value = !isExpanded.value;
  emit('expand', isExpanded.value);
}
</script>
